import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

const EditModeContext = createContext(null);

export const EditModeProvider = ({ children }) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [hasApplication, setHasApplication] = useState(false);
  const [hasDraft, setHasDraft] = useState(false);

  useEffect(() => {
    // console.log('EditModeContext - isEditMode changed to:', isEditMode); // 이 로그 제거
  }, [isEditMode]);

  const handleEditModeChange = useCallback((newValue) => {
    console.log('EditModeContext - handleEditModeChange called with:', newValue);
    if (newValue === true && !hasApplication && !hasDraft) {
      console.log('EditModeContext - 신청서나 초안이 없어서 edit 모드로 전환할 수 없습니다');
      return; // 신청서나 초안이 없으면 edit 모드로 전환하지 않음
    }
    setIsEditMode(newValue);
  }, [hasApplication, hasDraft]);

  const setApplicationState = useCallback((hasApp, hasDft) => {
    setHasApplication(hasApp);
    setHasDraft(hasDft);
  }, []);

  const value = {
    isEditMode,
    setIsEditMode: handleEditModeChange,
    hasApplication,
    hasDraft,
    setApplicationState
  };

  return (
    <EditModeContext.Provider value={value}>
      {children}
    </EditModeContext.Provider>
  );
};

EditModeProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useEditMode = () => {
  const context = useContext(EditModeContext);
  if (!context) {
    throw new Error('useEditMode must be used within a EditModeProvider');
  }
  return context;
}; 